import { memo, type Ref } from "react";

import { type CartGrouping } from "~/features/cart/cart/models/CartData";
import { useAlternateProducts } from "~/features/cart/cart/AlternateProductsContext";
import AlternateProducts from "~/features/cart/cart/components/AlternateProducts";
import ProductEntryList, { type ProductEntryListRef } from "~/features/cart/cartV2/ProductEntryList";

interface ProductTableProps {
  className?: string;
  group: CartGrouping;
  editMode?: boolean;
  onClear?: () => void;
  "data-test-id"?: string;
  scrollRef?: Ref<ProductEntryListRef>;
}

const ProductTable = (props: ProductTableProps) => {
  const { group, editMode, "data-test-id": testId } = props;
  const { alternateItems, handleClose } = useAlternateProducts();

  const isEmpty = group.entries.length === 0;

  if (isEmpty) {
    return alternateItems.map((item) => (
      <AlternateProducts
        key={item.index}
        orderEntryNumber={item.index}
        alternateProductsId={item.code}
        alternativesFor={item.designation}
        onClose={() => handleClose(item.index)}
      />
    ));
  }

  return <ProductEntryList group={group} editMode={editMode} scrollRef={props.scrollRef} />;
};

export default memo(ProductTable);
